import { render, staticRenderFns } from "./PrizeBreakdown.vue?vue&type=template&id=23ac5af4&scoped=true&"
import script from "./PrizeBreakdown.vue?vue&type=script&lang=js&"
export * from "./PrizeBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PrizeBreakdown.vue?vue&type=style&index=0&id=23ac5af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac5af4",
  null
  
)

export default component.exports